
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenWeatherCurvePoint {

    outageFraction: number;
    timeMinutes: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherCurvePoint: GenWeatherCurvePoint);

    constructor( input?: GenWeatherCurvePoint ) {
        if ( input && typeof input !== 'number' ) {
            this.outageFraction = input.outageFraction; // float [number]
            this.timeMinutes = input.timeMinutes; // float [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherCurvePoint[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherCurvePoint(a));
        } else {
          return [];
        }
    }
}

